module.exports = __webpack_public_path__ + "img/step4b-mobile-fr@2x.99e12a1b.webp";